module.exports = __webpack_public_path__ + "static/media/ridelightpro-5.3a5d7198.jpg";